import { render, staticRenderFns } from "./TasklistDrawers.vue?vue&type=template&id=3ed39b55"
import script from "./TasklistDrawers.vue?vue&type=script&lang=js"
export * from "./TasklistDrawers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports